import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { getAgentOwnershipStyle } from '@/lib/mock-agents-data';

export function OwnershipBadge({ ownership, className }: { ownership: string | null | undefined; className?: string }) {
  const style = getAgentOwnershipStyle(ownership);
  return (
    <Badge variant="outline" className={cn('text-[9px]', style.color, className)}>
      {style.label}
    </Badge>
  );
}
